import { useHistory } from 'react-router-dom';

//TODO: REFACTOR IN UPDATE REACT
const useSettings = () => {
  const navigate = useHistory();

  const handleNavigateAddFiles = () => {
    navigate.push('/add-files-ai');
  };
  const handleNavigateListFiles = () => {
    navigate.push('/list-files-ai');
  };

  return {
    handleNavigateAddFiles,
    handleNavigateListFiles,
  };
};
export default useSettings;
